import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import VipTablesRequests from "../VipTablesRequests";
import VipTablesTabs from "../VipTablesTabs";
import { Puff } from "react-loading-icons";
import { TextArea } from "../../../../../Layout/Forms/Form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../../../../../components/NavBar";
import TermsDefault from './termsDefault'

const TermsConditionsVenue = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    form: {
      terms: "",
    },
  });
  useEffect(() => {
    getTermsVenue()
  }, [])

  const getTermsVenue = async () => {
    setIsLoading(true);
    let info = await VipTablesRequests.getVenueTerms({ id_venues: params.id });
    if (info && info.status) {
      setState({
        ...state,
        form: info.data,
      });
    }
    setIsLoading(false);
  };

  const handleChangeInputs = (e) => {
    setState({
      ...state,
      form: {
        ...state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handlerSaveTerms = async () => {
    setIsLoading(true);
    let info = await VipTablesRequests.saveTermsVenues({
      ...state.form,
      id_venues: params.id,
    });
    if (info && info.status) {
      toast.success("Termos guardados com sucesso", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      toast.error("Ocorreu um erro a guardar os termos e condições", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setIsLoading(false);
  };

  const setDefaultTermsConditions = () => {
    setState({
      ...state,
      form: {
        ...state.form,
        terms: TermsDefault,
      },
    });
  };
  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A carregar termos...</div>
    </div>
  );

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb premium-breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/my/nightspots">Nightspots</Link>
            </li>
            <li className="breadcrumb-item active">Termos & Condições</li>
          </ol>
        </nav>

        <VipTablesTabs tab="terms" />

        {isLoading ? (
          <InsideLoading />
        ) : (
          <div className="row justify-content-center mt-4">
            <div className="col-12 col-xl-10">
              <div className="instruction-box p-4 p-md-5 rounded-4 border-0">
                <div className="row align-items-center mb-4">
                  <div className="col-12 col-md-7">
                    <h2 className="campaigns-section-title fs-2 mb-1">Termos & Condições</h2>
                    <p className="campaigns-section-subtitle mb-0">
                      Define as regras para guest list, reserva de mesas e venda de bilhetes.
                    </p>
                  </div>
                  <div className="col-12 col-md-5 d-flex justify-content-md-end mt-3 mt-md-0">
                    <button
                      className="btn-action btn-campaign-secondary px-4 rounded-pill w-auto py-2"
                      onClick={() => setDefaultTermsConditions()}
                    >
                      <i className="fa-solid fa-bolt me-2"></i>Carregar Exemplo
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <TextArea
                      label="O texto abaixo será apresentado aos teus clientes."
                      name="terms"
                      value={state.form.terms}
                      onChange={(e) => handleChangeInputs(e)}
                      rows={15}
                      errors={state.errors}
                      className="form-control glass-input"
                      style={{ minHeight: '400px' }}
                    />
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-12">
                    <button
                      className="btn-action glass-glow btn-campaign-primary px-5 py-3 rounded-pill w-auto ms-auto"
                      onClick={() => handlerSaveTerms()}
                    >
                      <i className="fa-solid fa-floppy-disk me-2"></i>Guardar Termos & Condições
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </NavBar>
  );
};

export default TermsConditionsVenue;
